/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestStepBaseAsJSON } from './AutoTestStepBaseAsJSON';
const AutoTestStepBaseInputAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['id', /* #__PURE__ */ codecOptional(codecNumber)],
    [
        'description',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecString)),
    ],
]), AutoTestStepBaseAsJSON);
export class AutoTestStepBaseInputAsJSON extends AutoTestStepBaseAsJSON {
    static decode(input) {
        return AutoTestStepBaseInputAsJSONParser.decode(input).map(res => new AutoTestStepBaseInputAsJSON(res));
    }
    static unsafeDecode(input) {
        return AutoTestStepBaseInputAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestStepBaseInputAsJSONParser.encode(data);
    }
    static schema() {
        return AutoTestStepBaseInputAsJSONParser.schema();
    }
}
